export const DEFAULT_LOCALE = "en-US";

export const HOMEPAGE_MESSAGE_BUNDLE_NAME = "pages.homepage";

export const TOOL_MESSAGING_MAP: Record<string, string> = {
    "get_patient_drug_regimens": "\n\n > Getting customer's drug regimens..."
} as const;

// Suggested response feedback context identifiers
export const SUGGESTED_RESPONSE_CONTEXT = {
    CONVERSE: 'converse_suggested_response',
    RECOMMENDATION: 'recommendation_suggested_response',
    SUMMARY: 'summary_suggested_response',
    DEFAULT: 'suggested_response'
} as const;

// Frontend metrics event types
export const METRICS_EVENTS = {
    COPY_RECOMMENDATION_SUGGESTED_RESPONSE: 'copy_recommendation_suggested_response',
    COPY_CONVERSE_SUGGESTED_RESPONSE: 'copy_converse_suggested_response',
    COPY_SUMMARY_SUGGESTED_RESPONSE: 'copy_summary_suggested_response',
    VIEW_RECOMMENDATION_DETAILS: 'view_recommendation_details',
    VIEW_SUMMARY_DETAILS: 'view_summary_details',
    // Emitted when the shoulder-tap poll-loop watchdog detects a stall and
    // force-restarts polling. Lets us evaluate, down the road, whether the
    // watchdog is actually firing in the field (and how often) or is dead code.
    SHOULDER_TAP_WATCHDOG_RESTART: 'shoulder_tap_watchdog_restart'
} as const;

// WebSocket message types
export const WEBSOCKET_MESSAGE_TYPES = {
    FRONTEND_METRIC: 'frontend_metric'
} as const;
